import { render, staticRenderFns } from "./MlbbSeriesGameWaiting.vue?vue&type=template&id=8e6ff0d6&scoped=true"
import script from "./MlbbSeriesGameWaiting.vue?vue&type=script&lang=js"
export * from "./MlbbSeriesGameWaiting.vue?vue&type=script&lang=js"
import style0 from "./MlbbSeriesGameWaiting.vue?vue&type=style&index=0&id=8e6ff0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6ff0d6",
  null
  
)

export default component.exports